<template >
  <div class="container-fluid" v-if="selbegtype">
    <h1>{{selbegtype.name}} ({{selbegtype.shortName}})</h1>
    <p>{{selbegtype.description}}</p>

    <button
      type="button"
      class="my-3 btn btn-primary"
      @click="_add"
    >Төрөл нэмэх</button>

    <!-- DataTales Example -->
    <div class="card shadow mb-4">
      <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Төрөлүүд</h6>
      </div>
      <div class="card-body" v-if="children!=null && children.length>0">
        <div class="table-responsive">
          <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
            <thead>
              <tr>
                <th>№</th>
                <th>Зураг</th>
                <th>Нэр</th>
                <th>Баруун/зүүн</th>
                <th>Урд/хойд</th>
                <th>Өнгө</th>
                <th>Дэлгэрэнгүй</th>
                <th>Үйлдэл</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(dep, index) in children" v-bind:key="dep.id">
                <td>{{index+1}}</td>
                <td>
                  <img
                    :src="_getImage(dep)"
                    style="border: 1px solid #ddd; border-radius: 4px; padding: 5px; width: 50px;"
                  />
                </td>
                <td>{{dep.name}} ({{dep.shortName}})</td>
                <td>
                  <span v-if="dep.side==true">yes</span>
                  <span v-else>no</span>
                </td>
                <td>
                  <span v-if="dep.vside==true">yes</span>
                  <span v-else>no</span>
                </td>
                <td>
                  <span v-if="dep.color==true">yes</span>
                  <span v-else>no</span>
                </td>
                <td>{{dep.description}}</td>
                <!-- <td>{{topic.createdAt | formatDate}}</td> -->
<td>
                  <button class="btn btn-primary btn-sm" @click="goDetail(dep)">xараx</button>
                  <button class="btn btn-warning btn-sm ml-2" @click="_editDepartment(dep)">засах</button>
                  <router-link
                    :to="{ name: 'ImageAdd', params: { objectPath: 'selbegtypes/'+schoolId+'/children/'+dep.id, folderName:'image_categories'} }"
                    class="btn btn-default btn-sm ml-2"
                  >Зураг оруулах</router-link>
                  <button class="btn btn-danger" v-if="dep.name && dep.name.length<=3" @click="_deleteDepartment(category)">устгах</button>
                </td>

                <td>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else class="alert alert-warning">Одоогоор мэдээлэл ороогүй байна.</div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="depModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="depModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="depModalLabel">Дэд ангилал</h5>

            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="user">
              <div class="form-group">
                <input
                  v-model.trim="department.name"
                  class="form-control"
                  aria-describedby="emailHelp"
                  placeholder="Нэр"
                />
              </div>
              <div class="form-group">
                <input
                  v-model.trim="department.shortName"
                  class="form-control"
                  aria-describedby="emailHelp"
                  placeholder="Товчилсон нэр"
                />
              </div>
              <div class="form-group">
                <label>Хайлтын түлхүүр үгс/таслалаар хуваан бичих/</label>
                <input
                  v-model.trim="department.tag"
                  class="form-control"
                  placeholder="Хайлтын түлхүүр үг"
                />
              </div>
              <div class="form-group">
                <textarea
                  rows="10"
                  v-model.trim="department.description"
                  class="form-control"
                  id="exampleInputPassword"
                  placeholder="Тайлбар мэдээлэл"
                />
              </div>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="colorCheck" v-model="department.color">
                <label class="form-check-label" for="colorCheck">Өнгө сонгох</label>
              </div>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="sideCheck" v-model="department.side">
                <label class="form-check-label" for="sideCheck">Баруун/Зүүн сонгох</label>
              </div>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="vsideCheck" v-model="department.vside">
                <label class="form-check-label" for="vsideCheck">Урд/Хойд сонгох</label>
              </div>

              <hr />
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Цуцлаx</button>
            <button
              @click="saveTopic"
              type="button"
              class="btn btn-primary btn-user btn-block"
              data-dismiss="modal"
            >Xадгалаx</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../firebaseConfig.js");
import { mapState } from "vuex";
import moment from "moment";
const axios = require('axios').default;
export default {
  name: "LessonDetail",
  data() {
    return {
      selbegtype: null,
      department: {
        name: null,
        shortName: null,
        description: null,
        color:false,
        side:false,
        vside:false
      },
      
      oldObject:{
        name:null,
        tag:null
      },
      children: []
    };
  },
  methods: {
    _getImage(obj) {
      if (obj.images != null && obj.images != undefined) {
        return obj.images[0]["fileUrl"];
      }
    },
    _getQA() {
      fb.db
        .collection("selbegtypes")
        .doc(this.schoolId)
        .onSnapshot(doc => {
          let selbegtype = doc.data();
          selbegtype.id = doc.id;
          this.selbegtype = selbegtype;
        });
      fb.db
        .collection("selbegtypes")
        .doc(this.schoolId)
        .collection("children")
        .orderBy("createdAt", "asc")
        .onSnapshot(querySnapshot => {
          this.children = [];
          querySnapshot.forEach(doc => {
            let object = doc.data();
            object.id = doc.id;
            if(object.color==undefined)
              object.color=false;
            if(object.side==undefined)
              object.side==false;
            if(object.vside==undefined)
              object.vside=false;

            // fb.db.collectionGroup("selbeg").where("type","==", doc.ref).where("active", "==", true).get().then(ccc=>{
            //   console.log(ccc.size);
            //   if(ccc){
            //     doc.ref.update({"numberOfItems": ccc.size});
            //   }
            // })
            this.children.push(object);
          });
        });
    },

    saveTopic() {
      if (
        this.department != null &&
        this.department != null &&
        this.department.name != "" &&
        this.department.description != ""
      ) {
        if (this.department.id != null && this.department.id != "") {
          fb.db
            .collection("selbegtypes")
            .doc(this.schoolId)
            .collection("children")
            .doc(this.department.id)
            .update({
              name: this.department.name,
              shortName: this.department.shortName,
              description: this.department.description,
              modifiedAt: new Date(),
              modifiedUser: fb.usersCollection.doc(
                this.$store.getters.currentUser.uid
              ),
              
              color: this.department.color!=undefined?this.department.color:false,
              side: this.department.side!=undefined?this.department.side:false,
              vside: this.department.vside!=undefined?this.department.vside:false,
              tag: this.department.tag!=undefined?this.department.tag:null
            });
          if(this.department.tag!=undefined && this.department.tag!=null && this.department.tag!='' && this.oldObject!=null && this.oldObject!=undefined && this.oldObject.tag!=this.department.tag){
            axios.post('http://43.231.113.102:8080/selbeg/api/search/tag/type?tag='+this.department.tag+"&typeId="+this.department.id+"&typeName="+this.oldObject.name)
            .then(function (response) {

            })
            .catch(function (error) {

            });
          }
        } 
        else {
          this.department.createdAt = new Date();
          fb.db
            .collection("selbegtypes")
            .doc(this.schoolId)
            .collection("children")
            .doc()
            .set(this.department);
          fb.db
            .collection("selbegtypes")
            .doc(this.schoolId)
            .update({
              numberOfDepartments: fb.firestore.FieldValue.increment(1)
            });
        }
        this.department = {
          name: null,
          shortName: null,
          description: null,
          color:false,
          side:false,
          vside:false,
          tag:null
        };
        this.oldObject= {name:null, tag:null};
      }
    },

    goDetail(dep) {
      this.$router.push({
        name: "SelbegSubTypeDetail",
        params: { schoolId: this.schoolId, departmentId: dep.id }
      });
    },
    _editDepartment(dep) {
      this.department = Object.assign({}, dep);
      this.oldObject= Object.assign({}, dep);
      $("#depModal").modal("toggle");
    },

    _add() {
      this.object = {};
      this.oldObject= {name:null, tag:null};
      $("#depModal").modal("toggle");
    },
    _deleteDepartment(dep) {
      var result = confirm("Та " + dep.name + " устгах уу?");
      if (result) {
        fb.db
          .collection("selbegtypes")
          .doc(this.schoolId)
          .collection("children")
          .doc(dep.id)
          .delete();
      }
    }
  },
  computed: {
    ...mapState(["userProfile", "currentUser"])
  },
  props: {
    schoolId: {
      required: true
    }
  },
  created() {
    var _this = this;
    console.log(this.schoolId);
    if (this.schoolId != null && this.schoolId != "") this._getQA();
  },
  filters: {
    formatDate(val) {
      if (val != null) {
        if (!val) {
          return "-";
        }
        let date = val.toDate();
        return moment(date).fromNow();
      }
      return "-";
    }
  }
};
</script>

